import { render } from "./ApplicationMark.vue?vue&type=template&id=66714c78"
const script = {}

import exportComponent from "/var/www/dmp/releases/1776447368/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__